export const PRIMARY_GREEN = '#4caf50';
export const SECONDARY_GRAY = '#b7b7b7';
export const WHITE = '#fff';
export const FOREIGN_CURRENCY_TRANSIENT_PROP = '$foreignCurrency';
export const IS_EXPORT_MODE_TRANSIENT_PROP = '$isExportMode';
export const PROPS_NOT_TO_BE_FORWARDED_TO_BUTTON = [FOREIGN_CURRENCY_TRANSIENT_PROP, IS_EXPORT_MODE_TRANSIENT_PROP];
